// React
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components
import LoginProvider from '../components/LoginProvider';
import { MinimalHeader, MinimalFooter } from '@mobilitystore/components-interface';

// Actions
import { logout } from '../actions/LoginAction';
import loading from '../actions/LoaderAction';

// Assets
import {CDN_LINK} from '../assets/img';

// Utils
import { getDeviceClass, formatMessage } from '../utils';

// Css
import './index.scss';

function LoginContainer(props) {
  const [updatedFooterTabs, setUpdatedFooterTabs] = useState([]);
  const footerContent = props?.content?.components?.footer;
  const headerContent = props?.content?.components?.header;
  const currentYear = new Date().getFullYear();
  const entityName = formatMessage(footerContent?.name, currentYear);
  const deviceClass = getDeviceClass();

  useEffect(() => {
    if (footerContent?.menu) {
      const newFooterTab = {
        id: '5',
        name: 'Privacy settings',
        onClick: () => showDockPrivacySettings()
      };
      const updatedTabs = [...footerContent.menu, newFooterTab];
      setUpdatedFooterTabs(updatedTabs);
    }
  }, [footerContent]);

  async function showDockPrivacySettings() {
    await customElements.whenDefined('dock-privacy-settings');
    const dockPrivacySettings = document.querySelector('dock-privacy-settings');
    dockPrivacySettings.setAttribute('visible', 'true');
  }

  const signOut = () => {
    props.logout();
  };

  useEffect(() => {
    if (props.location.pathname === '/logout') {
      signOut();
    }
  }, [props.location.pathname]);

  useEffect(() => {
    axios.interceptors.request.use(
      function (config) {
        // spinning start to show
        props.loading(true);
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        // spinning hide
        props.loading(false);
        return response;
      },
      function (error) {
        props.loading(false);
        return Promise.reject(error);
      }
    );
  }, []);

  return (
    <div className={`login-container ${deviceClass}`}>
      <MinimalHeader
        className='login-minimal-header'
        align='left'
        isLoggedIn={true}
        logo={{
          image: `${CDN_LINK}/${headerContent?.images?.logo?.image}`,
          alt: headerContent?.images?.logo?.alt
        }}
        onLogoClick={() => (window.location.href = '/')}
      />
      <LoginProvider {...props} />
      <MinimalFooter
        className='footer-component'
        footerTabs={updatedFooterTabs}
        entityName={entityName}
      />
    </div>
  );
}

const mapStateToProps = (redux_state) => ({
  loader: redux_state.LoaderReducer,
  content: redux_state.ContentReducer.content
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      logout,
      loading
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
